import { Component, Input } from '@angular/core';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
@Component({
  selector: 'app-common-bulk-print',
  templateUrl: './common-bulk-print.component.html',
  styleUrls: ['./common-bulk-print.component.css']
})
export class CommonBulkPrintComponent {
  @Input() columns: any[] = []; // Table columns definition
  @Input() data: any[] = []; // Data to be displayed
  @Input() downloadPdf: boolean = true;
  @Input() print: boolean = true;

  generatePrintContent(columns: any[], data: any[]): any {
    let tableContent = `
      <html>
        <head>
          <title>Print</title>
          <style>
            body {
              font-family: Arial, sans-serif;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
            }
            th, td {
              border: 1px solid #ddd;
              padding: 5px;
            }
            th {
              font-weight: bold;
            }
            td:first-child {
            // width: 30%;
            font-weight: bold;
            }
            h2 {
              text-align: left;
            }
          </style>
        </head>
        <body>
    `;

    data.forEach((record, index) => {
      tableContent += `
        <table>
          <tbody>
      `;
      columns.forEach((col: any) => {
        tableContent += `
          <tr>
            <td style="font-weight: bold;">${col.header}</td>
            <td>${record[col.key] || ''}</td>
          </tr>
        `;
      });
      tableContent += `
          </tbody>
        </table>
      `;
    });

    tableContent += `</body></html>`;
    return tableContent;
  }

  printRecords(columns: any[], data: any[]): void {
    const printContent = this.generatePrintContent(columns, data);

    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.print();
    } else {
      console.error('Failed to open a new print window.');
    }
  }

  downloadPDF(columns: any[], data: any[]): void {
    const doc = new jsPDF();
    let startY = 20; // Initial Y position for the first table

    data.forEach((record) => {
      const rows = columns.map((col) => {
        return [col.header, record[col.key] || ''];
      });

      // Set the font size for the document
      doc.setFontSize(8);

      startY += 10; // Adjust starting Y position for tables

      // Use autoTable to generate a table for each record
      (doc as any).autoTable({
        body: rows,
        startY: startY,
        theme: 'grid',
        margin: { top: 20, left: 10, right: 10, bottom: 10 },
        styles: {
          fontSize: 8,
          cellPadding: 3,
        },
        bodyStyles: {
          lineColor: [0, 0, 0], // Border color
          lineWidth: 0.2, // Border width
        },
        columnStyles: {
          0: { fontStyle: 'bold' } // Bold the first column (headers)
        }
      });

      const tableHeight = doc.internal.pageSize.height - startY - 10;
      startY += tableHeight; 
    });
    doc.save('print-details.pdf');
  }
}
